// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__fYwn3","consentsList":"PatientConsents_consentsList__YkZYm","consentsListEmpty":"PatientConsents_consentsListEmpty__3x56x"};